<template>
    <v-card v-if="ready" class="pa-0 elevation-0 scorecard-card">
        <div :class="'pa-1 pt-2 title-head ' + cardStyle">
            {{title}}
        </div>
        <div :class="'pa-3 body-stat ' + cardStyle">
            <div class="stat-detail">
                <div class="score-card-label" v-if="!loading">
                    {{this.prev_week.label}}
                </div>
                <div class="stat-number pt-4" v-if="!loading">
                    <span :class="the_data[statusKey] > 999999 ? 'large' : ''">
                        <span >{{ the_data[statusKey] }}</span>
                    </span>
                </div>
                <div class="stat-number" v-if="loading">
                    <v-progress-circular indeterminate></v-progress-circular>
                </div>
            </div>
        </div>
        <div class="footer-expand">
            <v-expansion-panels>
                <v-expansion-panel>
                    <v-expansion-panel-header class="expansion-label">
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <div class="stat-notes">
                            <slot></slot>
                        </div>
                        <v-divider class="py-3"></v-divider>
                        <v-btn block color="q_green_1" @click="gotoDrillDown" v-if="drillDownRoute">
                            <v-icon left v-if="!hideButtonIcon">fas fa-chart-pie </v-icon>
                            {{ drillDownLabel }}
                        </v-btn>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </div>
    </v-card>
</template>

<script>
import QuilityAPI from '@/store/API/QuilityAPI.js'
import { debounce } from 'vue-debounce'

export default {
    name: "QScoreCard",
    props: {
        'title': {
            type: String,
            default: 'Title'
        },
        'format': {
            type: String,
            default: ''
        },
        'label': {
            type: String,
            default: 'Label'
        },
        'apiEndpoint': {
            type: String,
            default: 'submitted'
        },
        'drillDownLabel': {
            type: String,
            default: 'Agent Breakdown'
        },
        'drillDownRoute': {
            type: String,
            default: 'Drilldown_Submitted'
        },
        'cardStyle': {
            type: String,
            default: ''
        },
        'agentCode': {
            type: String,
            default: null
        },
        'filters': {
            type: Object,
            default: function() {
                return {}
            }
        },
        'defaultGoal': {
            type: Number,
            default: null
        },
        'hideGoal': {
            type: Boolean,
            default: false
        },
        'allData': {
            type: Boolean,
            default: false
        },
        'hideButtonIcon': {
            type: Boolean,
            default: false
        },
        'hideHistoricalData': {
            type: Boolean,
            default: false
        },
        'allowRefresh': {
            type: Boolean,
            default: false
        },
        'dataRequiresFilters': {
            // If set to true data load won't be called on mounted, will wait for filter values to load.
            // Could probably default to true but haven't checked with all the cards.
            type: Boolean,
            default: false,
        },
        'statusKey': {
            type: String,
            default: 'overall'
        }
    },
    data: function() { // data internal to component (not available outside)
        return {
            the_data: {
                data: [],
                Goal: null,
            },
            loading: false,
            loading_more: false,
            ready: false,
            prev_week: null,
        }
    },
    mounted: function() {
        this.prev_week = this.getAvailableBusinessDates('week', false, false)[0]

        if (! this.dataRequiresFilters) {
            this.loadData();
        }

        this.ready = true
    },
    methods: {
        loadData: function() {
            var g = this
            this.loading = true
            const date = new Date()

            let day = date.getDate()
            let month = date.getMonth() + 1
            let year = date.getFullYear()

            //get the data for the agent for this scorecard.
            var q_name = "getScoreCard_" + this.apiEndpoint
            QuilityAPI.cancelQRequest(q_name);
            var params = {
                ...this.filters,
                date: `${year}-${month}-${day}`
            }
            QuilityAPI.getRequest("/api/private/scorecards/" + this.apiEndpoint + "/" + this.agentCode, params, q_name).then(function(json) {
                        g.the_data = json
                        g.loading = false;
                    },
                    function(error) {
                        g.loading = false;
                        //g.showError("There was a problem loading the '" + g.title + "' scorecard. Give it a few minutes and try refreshing.")
                        return error
                    })
                .catch(function(err) {
                    console.log(err)
                });
        },
        gotoDrillDown: function() {
            var params = {
                agent_code: this.agentCode,
            }

            let level = 'personal'

            switch (this.apiEndpoint) {
                case 'onboarding-recruiting-personal':
                    level = 'personal'
                    break
                case 'onboarding-recruiting-baseshop':
                    level = 'baseshop'
                    break
                case 'onboarding-recruiting-totalagency':
                    level = 'totalagency'
                    break
                default:
                    level = 'personal'
                    break
            }
            const date = new Date()

            let day = date.getDate()
            let month = date.getMonth() + 1
            let year = date.getFullYear()

            this.$router.push({
                name: 'Drilldown_QuilityOnboardingPortalRecruitingStatus',
                params: params,
                query: {
                    statusKey: this.statusKey,
                    title: `${this.title} Drilldown`,
                    agent_code: this.agentCode,
                    date: `${year}-${month}-${day}`,
                    level: level
                }
            });
        }
    },
    watch: {
        'agentCode': function(newV, oldV) {
            var g = this;
            var q_name = "getScoreCard_" + this.apiEndpoint
            QuilityAPI.cancelQRequest(q_name);
            this.the_data = {
                data: [],
                Goal: null,
            }
            g.$nextTick(g.loadData)
        },
        filters: {
            deep: true,
            handler: function() {
                var q_name = "getScoreCard_" + this.apiEndpoint
                QuilityAPI.cancelQRequest(q_name);
                this.the_data = {
                    data: [],
                    Goal: null,
                }
                var g = this
                g.$nextTick(g.loadData);
            }
        }
    },
}
</script>